<template>
  <div class="ticket-page">
    <div class="page-header">
      <h3>打印准考证</h3>
      <div class="meta" v-if="examId">考试ID：{{ examId }}</div>
    </div>

    <!-- 单考试打印：仅审核通过且已缴费时渲染 -->
    <div class="content" v-if="examId">
      <div class="content-actions">
        <button class="btn-back" @click="goBack">{{ backLabel }}</button>
      </div>
      <template v-if="submission && ticket && (ticket.is_published === true || ticket.published === true)">
        <ExamRegistrationForm :exam="examDetail ? examDetail : { id: examId }" :submission="submission" :ticket="ticket"
          :editable="false" :layout="'ticket'" :actions-mode="'print'" />
      </template>
      <div v-else class="empty">该考试尚不可打印准考证（需审核通过且已缴费，且准考证已发布）。</div>
    </div>

    <!-- 列表打印：仅展示审核通过且已缴费的报名 -->
    <div class="content" v-else>
      <div v-if="listLoading" class="empty">正在加载可打印的准考证...</div>
      <div v-else-if="tickets.length === 0" class="empty">暂无可打印的准考证（需审核通过且已缴费）。</div>
      <table v-else class="simple-table">
        <thead>
          <tr>
            <th>考试名称</th>
            <th>考试时间</th>
            <th>状态</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="t in paginatedTickets" :key="t.exam_id">
            <td>{{ t.exam_title || t.exam_name }}</td>
            <td>
              <span v-if="hasExamTime(t)">{{ t.exam_time_text || formatRange(t.exam_start_time, t.exam_end_time) }}</span>
              <span v-else style="color: #999">未开始</span>
            </td>
            <td>
              <span v-if="t.is_published" style="color: green">已发布</span>
              <span v-else style="color: orange">未发布</span>
            </td>
            <td>
              <button class="btn-back" @click="openTicket(t)" :disabled="!canPrint(t)"
                :style="!canPrint(t) ? { opacity: 0.5, cursor: 'not-allowed' } : {}">查看并打印</button>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 分页 -->
      <div class="pagination">
        <span class="pagination-total">共 {{ tickets.length }} 条</span>
        <select v-model="ticketPageSize" @change="ticketPage = 1" class="page-size-select">
          <option :value="10">10条/页</option>
          <option :value="20">20条/页</option>
          <option :value="50">50条/页</option>
        </select>
        <button class="btn-page" :disabled="ticketPage <= 1" @click="ticketPage--">‹</button>
        <span class="page-current">{{ ticketPage }}</span>
        <button class="btn-page" :disabled="ticketPage >= ticketTotalPages" @click="ticketPage++">›</button>
      </div>
    </div>
  </div>
</template>

<script>
import ExamRegistrationForm from "./ExamRegistrationForm.vue"
import { getExam, listMyApplications, listMyTickets } from "../api/exams"
export default {
  name: 'AdmissionTicketPage',
  components: { ExamRegistrationForm },
  props: { examId: { type: [String, Number], default: '' }, source: { type: String, default: '' } },
  data() {
    return { examDetail: null, submission: null, ticket: null, loading: false, listLoading: false, tickets: [], from: this.source || '', ticketPage: 1, ticketPageSize: 10 }
  },
  async mounted() {
    try {
      if (!this.from) {
        const f1 = localStorage.getItem('ticket_from_list')
        const f2 = localStorage.getItem('ticket_from_my_registration')
        if (f1 === '1') this.from = 'list'
        else if (f2 === '1') this.from = 'my'
      }
    } catch (_) { }
    if (this.examId) {
      await this.fetchExamDetail()
      await this.fetchSubmission()
    } else {
      await this.fetchTickets()
    }
  },
  methods: {
    async fetchExamDetail() {
      try { if (this.examId) this.examDetail = await getExam(this.examId) } catch (e) { }
    },
    async fetchSubmission() {
      try {
        const list = await listMyApplications()
        const found = Array.isArray(list) ? list.find(x => String(x?.exam_id || x?.exam?.id || '') === String(this.examId)) : null
        
        if (!found) {
          this.error = '未找到该考试的报名记录';
          this.submission = null
          this.ticket = null
          return
        }
        
        // 仅在审核通过且已缴费时允许打印
        if (String(found.audit_status) === 'approved' && String(found.payment_status) === 'paid') {
          this.submission = found
          this.error = ''
          // 获取准考证信息
          await this.fetchTicket()
        } else {
          const statusMsg = found.audit_status !== 'approved' 
            ? '报名尚未审核通过' 
            : '尚未完成缴费';
          this.error = `无法打印准考证：${statusMsg}`;
          this.submission = null
          this.ticket = null
        }
      } catch (e) {
        console.error('加载报名信息失败', e)
        this.error = '加载报名信息失败，请稍后重试';
        this.submission = null
        this.ticket = null
      }
    },
    async fetchTicket() {
      try {
        const tickets = await listMyTickets()
        console.log('listMyTickets返回的数据:', tickets)
        this.ticket = Array.isArray(tickets) ? tickets.find(t => String(t.exam_id) === String(this.examId)) : null
        console.log('当前examId:', this.examId)
        console.log('匹配到的ticket:', this.ticket)
      } catch (e) {
        console.warn('获取准考证信息失败', e)
        this.ticket = null
      }
    },
    async fetchTickets() {
      this.listLoading = true
      try {
        // 优先使用后端“我的准考证”接口（可能已按条件过滤）
        let list = []
        try {
          list = await listMyTickets()
        } catch (e) { list = [] }
        // 若接口不可用或返回为空，则使用报名列表过滤
        if (!Array.isArray(list) || list.length === 0) {
          const apps = await listMyApplications()
          list = (Array.isArray(apps) ? apps : []).filter(a => a.audit_status === 'approved' && a.payment_status === 'paid')
            .map(a => ({
              exam_id: a?.exam_id || a?.exam?.id,
              exam_title: a?.exam_title || a?.exam_name || a?.exam?.title || a?.exam?.name,
              exam_start_time: a?.exam?.start_time,
              exam_end_time: a?.exam?.end_time
            }))
        } else {
          // 规范字段名，便于模板渲染，同时保留所有准考证信息字段
          list = list.map(t => ({
            ...t, // 保留所有原始字段
            exam_id: t?.exam_id || t?.exam?.id,
            exam_title: t?.exam_title || t?.exam_name || t?.exam?.title || t?.exam?.name,
            exam_start_time: t?.exam?.start_time,
            exam_end_time: t?.exam?.end_time,
            exam_time_text: t?.exam_time_text,
            is_published: t?.is_published
          }))
        }
        this.tickets = list.filter(x => x.exam_id != null)
      } catch (e) {
        console.warn('加载准考证列表失败', e)
        this.tickets = []
      } finally { this.listLoading = false }
    },
    goBack() {
      const prev = this._popHistory()
      if (prev && prev.hash === '#home') {
        if (prev.subNav === '准考证打印') {
          try { localStorage.setItem('redirect_to_ticket_home', '1') } catch (_) { }
        } else {
          try { localStorage.setItem('redirect_to_my_registration', '1') } catch (_) { }
        }
        window.location.hash = 'home'
        return
      }
      if (prev && prev.hash) {
        window.location.hash = prev.hash.replace(/^#?/, '#')
        return
      }
      window.location.hash = 'home'
    },
    openTicket(t) {
      const id = t?.exam_id
      if (id == null) return
      this._pushHistory({ hash: '#home', nav: '我的报名', subNav: '准考证打印' })
      window.location.hash = `admit-card/${id}`
    },
    // 检查是否有考试时间
    hasExamTime(t) {
      return !!(t.exam_time_text || (t.exam_start_time && t.exam_end_time))
    },
    // 检查是否可以打印（已发布即可）
    canPrint(t) {
      return t.is_published === true
    },
    formatRange(s, e) {
      return (s && e) ? `${this.formatDate(s)} - ${this.formatDate(e)}` : '-'
    },
    formatDate(str) {
      try { const d = new Date(str); return isNaN(d) ? '-' : `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}` } catch { return '-' }
    },
    _readHistory() {
      try { return JSON.parse(localStorage.getItem('app_history') || '[]') } catch (_) { return [] }
    },
    _pushHistory(state) {
      const arr = this._readHistory(); arr.push(state); const keep = arr.slice(-20);
      try { localStorage.setItem('app_history', JSON.stringify(keep)) } catch (_) { }
    },
    _popHistory() {
      const arr = this._readHistory(); const prev = arr.pop();
      try { localStorage.setItem('app_history', JSON.stringify(arr)) } catch (_) { }
      return prev
    }
  },
  computed: {
    backLabel() {
      return '返回打印准考证列表'
    },
    ticketTotalPages() {
      return Math.ceil(this.tickets.length / this.ticketPageSize) || 1
    },
    paginatedTickets() {
      const start = (this.ticketPage - 1) * this.ticketPageSize
      return this.tickets.slice(start, start + this.ticketPageSize)
    }
  }
}
</script>

<style scoped>
.ticket-page {
  padding: 16px;
}

.page-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.page-header h3 {
  color: #0066cc;
  margin: 0;
}

.meta {
  color: #888;
}

.btn-back {
  margin-left: auto;
  background: #f0f0f0;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  padding: 6px 12px;
  cursor: pointer;
}

.content {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
}

.content-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.empty {
  color: #666;
  padding: 16px;
}

.simple-table {
  width: 100%;
  border-collapse: collapse;
}

.simple-table th,
.simple-table td {
  border-bottom: 1px solid #eee;
  padding: 8px;
  text-align: left;
}

/* 仅用于打印：隐藏页头与操作区，仅展示准考证主体 */
@media print {

  .page-header,
  .content-actions,
  .simple-table,
  .empty,
  .pagination {
    display: none !important;
  }

  .ticket-page {
    padding: 0 !important;
  }

  .content {
    padding: 0 !important;
    border-radius: 0 !important;
  }
}

/* 分页样式 */
.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #eee;
}

.pagination .pagination-total {
  color: #666;
  font-size: 14px;
}

.pagination .page-size-select {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.pagination .btn-page {
  padding: 6px 12px;
  background: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
}

.pagination .btn-page:hover:not(:disabled) {
  background: #e9ecef;
}

.pagination .btn-page:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination .page-current {
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #1677ff;
  color: #fff;
  border-radius: 4px;
  font-size: 13px;
}

.pagination .page-info {
  font-size: 13px;
  color: #666;
}
</style>
